import { Component, OnInit, OnDestroy, Input } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";

import { Observable, Subscription } from "rxjs";
import { select, Store } from "@ngrx/store";
import { AppState, loadedTenantState } from "src/app/store/reducers";

import { TranslateService } from "@ngx-translate/core";
import { SnackbarService } from "../../services/snackbar/snackbar.service";

import { BaseDatepicker, DATEPICKER_FORM } from "../../base-classes/base-datepicker/base-datepicker";

import { MatDialog } from "@angular/material/dialog";
import { AlertDialogComponent } from "../dialogs/alert-dialog/alert-dialog.component";

@Component({
  selector: "app-datepicker",
  templateUrl: "./datepicker-range.component.html",
  styleUrls: ["./datepicker-range.component.scss"],
})
export class DatePickerComponent
  extends BaseDatepicker
  implements OnInit, OnDestroy
{
  dateTimeFormat: string;
  tenantData$: Observable<any>;

  tenantDataSub: Subscription;

  customDates = true;

  dateModes = [
    {
      id: "CUSTOM",
      name: "Dates.customRange",
      icon: "edit_calendar"
    },
    {
      id: "TODAY",
      name: "Dates.dayRange",
      icon: "calendar_today",
    },
    {
      id: "YESTERDAY",
      name: "Dates.yesterdayRange",
      icon: "today",
    },
    {
      id: "WEEK",
      name: "Dates.weekRange",
      icon: "date_range",
    },
    {
      id: "MONTH",
      name: "Dates.monthRange",
      icon: "calendar_month",
    },
  ];

  @Input() hasInitialLoad: boolean = true;
  @Input() hasClearDates: boolean = false;
  @Input() set hasCustomDates(bool: boolean) {
    if (bool === false) {
      this.dateModes.shift();
      this.customDates = false;
    }
  }

  constructor(
    public store: Store<AppState>,
    public fb: FormBuilder,
    public translate: TranslateService,
    public snackbarService: SnackbarService,
    public dialog: MatDialog
  ) {
    super(store, fb, translate, snackbarService);
  }

  ngOnInit(): void {
    this.tenantData$ = this.store.pipe(select(loadedTenantState));

    this.loadTenantDateTimeFomat();
    this.createDatePickerForm();
    this.setDefaultSelection();
    this.loadDates();
  }

  loadTenantDateTimeFomat() {
    this.tenantDataSub = this.tenantData$.subscribe((data: any) => {
      if (data) {
        this.dateTimeFormat = data.datetimeFormat;
      }
    });
  }

  setDefaultSelection() {
    this.datepickerFormGroup.get(DATEPICKER_FORM.modes).setValue(this.selectedMode);
  }

  loadDates() {
    if (!this.hasInitialLoad) {
      return;
    }

    this.loadDatePicker();
  }

  clearFormControl(form: FormGroup, dateControl: string): void {
    if (!form.controls[dateControl].value) {
      return;
    }

    if (this.hasInitialLoad) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        minWidth: "350px",
        data: {
          message: this.translate.instant("Dates.warningRemoveFilter"),
          message2: this.translate.instant("Dates.warningRemoveFilter2"),
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          form.controls[dateControl].setValue(null);
          this.calculateDate(null);
        }
      });
    } else {
      form.controls[dateControl].setValue(null);
      this.calculateDate(null);
    }
  }

  ngOnDestroy(): void {
    if (this.tenantDataSub) {
      this.tenantDataSub.unsubscribe();
    }
  }
}
